export default flowCtrl

/** @ngInject */
function flowCtrl($scope) {
    $scope.hint = {
        body: `Et jusqu’à 20% de moins avec un thermostat programmable ou thermostat \
à horloge (réduction de la température la nuit ou en cas d’absence).`,
        implementation: 1,
        investment: 1,
        large: true,
        room: 'kitchen',
        saving: 2,
        summary: `Vous consommerez jusqu’à 10 % de moins avec un thermostat simple \
(le chauffage se déclenche en fonction d’une température choisie)`,
        title: '10% de moins grâce à un thermostat',
    }
}



// WEBPACK FOOTER //
// ./src/states/flow/flow.js